import type { MachineSetupRepository } from '../data/machine-setup-repository';
import type { ApplyAttributeItem } from '../types/machine-setup-types';

export class ApplyAttributesUseCase {
  constructor(private readonly repository: MachineSetupRepository) {}

  async execute(machineId: number, attributes: ApplyAttributeItem[]): Promise<{ isSuccess: boolean; message: string | null }> {
    return this.repository.applyAttributes(machineId, attributes);
  }
}
